export default __webpack_public_path__ + "static/media/(35).1b8124db.jpg";